import React from 'react'
import { Link } from 'react-router-dom'

import { globalSettings } from '../../helpers/settings'
import Menu from '../main/Menu'

export default function Privacy() {

    return (
        <div>
            <Menu viewName={'home'} process={'privacy'} />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.privacy.es}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    {/* <li className='breadcrumb-item'><a href='/'>{globalSettings?.labels?.home?.es}</a></li> */}
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.es}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.privacy.es}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>

                            <section className='col-lg-6 connectedSortable'>

                                <div className='card shadow-lg'>
                                    <div className='card-body'>
                                    </div>
                                </div>

                                <div className='card shadow-lg'>
                                    <div className='card-body'>
                                    </div>
                                </div>

                            </section>

                            <section className='col-lg-6 connectedSortable'>

                                <div className='card shadow-lg'>
                                    <div className='card-body'>
                                    </div>
                                </div>

                                <div className='card shadow-lg'>
                                    <div className='card-body'>
                                    </div>
                                </div>

                            </section>

                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}